import React from "react";
import { useTranslation } from "react-i18next";

//Style
import "./DocsByYearComponent.css";

const DocsByYearComponent = ({ docs }) => {
  const { t } = useTranslation();

  return (
    <div className="docs-by-year-container">
      <p className="title-docs">{t(docs.title)}:</p>
      <ul className="list-container">
        {docs.docs.map((doc, i) => {
          return (
            <li key={i}>
              <a
                className="anchor-doc"
                href={doc.document}
                target="_blank"
                title={doc.titleDoc}
                rel="noreferrer"
              >
                {t(doc.titleDoc)}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default DocsByYearComponent;
